"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var containsInclusive = function containsInclusive(x, start, end) {
  return x >= start && x <= end;
};

var _default = containsInclusive;
exports["default"] = _default;